/* Probably Late — Lenis smooth scrolling
   Slow, heavy ease on wheel/touch scrolling, site-wide. Exposed as
   window.plLenis so other scripts (mobile menu, preloader) can stop/start it. */
(function () {
  if (!window.Lenis) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  /* duration 0.8 + expo-out easing matches the feel of oharchitecture.com.au */
  var lenis = new Lenis({
    duration: 0.8,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    smoothWheel: true
  });
  window.plLenis = lenis;

  function raf(time) {
    lenis.raf(time);
    window.requestAnimationFrame(raf);
  }
  window.requestAnimationFrame(raf);
})();

